import { useApiPostQuery } from '../useApi'

export const useLecturesStatus = (requestData = {}) => {
  return useApiPostQuery<any>(
    '/lectures/status',
    ['lecturesStatus', requestData],
    requestData,
    true
  )
}
